var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isEditModeActive
      ? _c("div", [
          _c("div", { staticClass: "main-container" }, [
            _c(
              "div",
              { staticClass: "flex-container" },
              [
                _c("category-select-recursive", {
                  attrs: { "parent-category-slug": "root" },
                  model: {
                    value: _vm.categorySlug,
                    callback: function ($$v) {
                      _vm.categorySlug = $$v
                    },
                    expression: "categorySlug",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.count != null
              ? _c("span", { staticClass: "number-span" }, [
                  _c("span", { staticClass: "mr-1 is-size-7" }, [
                    _vm._v(_vm._s(_vm.$t("common.count")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.count))]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isEnabledUndo === true && _vm.initialCategorySlug
            ? _c("div", { staticClass: "mt-1" }, [
                _c(
                  "a",
                  {
                    staticClass: "u-clickable",
                    on: {
                      click: function ($event) {
                        return _vm.updateCategoryEditMode(false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("common.undo")) + "\n      "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      : _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.inputtedCategoryLabel))]),
          _vm._v(" "),
          _c("span", [
            _c(
              "a",
              {
                staticClass: "ml-4 u-clickable",
                on: {
                  click: function ($event) {
                    return _vm.updateCategoryEditMode(true)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("common.edit")))]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }